<template>
    <div class="modal fade" :id="'ModalConfirmacao_' + id" tabindex="-1" :open="show" role="dialog" aria-labelledby="TituloModalCentralizado" aria-hidden="true" :style="customModalMain">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content p-3">
                <div class="modal-header pb-2 pe-2 ps-3 pt-2" style="border-bottom: none !important;">
                    <h6 class="modal-title">{{ title }}</h6>
                </div>
                <div class="modal-body ps-2 pb-4">
                    <div class="container-fluid text-center" style="max-height: 150px !important">
                        <span class="modal-pedido-title-padrao text-muted ">{{ description }} </span>
                        <span class="modal-pedido-title-padrao text-muted ">{{ red }}</span>
                    </div>
                    <div class="mt-3" v-if="haveText">
                        <textarea class="form-control" rows="3" v-model="dsMotivo"></textarea>
                    </div>
                </div>
                <div class="modal-footer ps-2 col-12" style="border-top: none !important;">
                    <button type="button" class="col-6 btn btn-close-clean-v2 text-danger ps-0"
                        data-bs-dismiss="modal">Fechar</button>
                    <button type="button" class="col-6 btn btn-grid-editar-lista" data-bs-dismiss="modal"
                        @click="actionButton">
                        <i :class="customIcon()"></i>
                        {{ action }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ModalConfirmacao',
        props: {
            id: {
                type: String,
                default: '0'
            },
            title: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            red: {
                type: String,
                default: '',
            },
            action: {
                type: String,
                default: ''
            },
            show: {
                type: Boolean,
                default: false
            },
            isDelete: {
                type: Boolean,
                default: true
            },
            haveText: {
                type: Boolean,
                default: false
            },
            customModalMain: {
                type: String,
                default: 'z-index:1056'
            },
        },
        data() {
            return {
                dsMotivo: ''
            }
        },
        components: {            
        },
        methods: {
            actionButton() {
                let $this = this;

                $this.$emit('actionReturn', $this.id, $this.dsMotivo);

                setTimeout(() => {
                    $this.dsMotivo = ''
                }, 200);
            },
            customIcon() {
                if (this.isDelete == true) {
                    return 'fas fa-trash pe-2'
                } else {
                    return 'fa fa-paper-plane pe-2 '
                }
            }
        },
        mounted() {

        },
        watch: {

        }
    }

</script>

<style scoped lang="scss">

</style>